/**
 * Component: Countdown
 * -----------------------------------------------------------------------------
 * Countdown logic for countdown banner.
 *
 */
var countdownSection = document.getElementById('countdownSection')
if (countdownSection) {
  var startDateTimeStr = countdownSection.getAttribute('data-start-date')
  var startDate = parseDateTime(startDateTimeStr)
  var endDateTimeStr = countdownSection.getAttribute('data-end-date')
  var endDate = parseDateTime(endDateTimeStr)
  var bannerExpiredText = document.getElementById('bannerTextExpired').getAttribute('data-expired-text')
  var countdownInterval
}

/**
 * Parse current date and time.
 * @param {String} dateTimeStr - Date and time string.
 */
function parseDateTime(dateTimeStr) {
  var parts = dateTimeStr.split(' ')
  var datePart = parts[0]
  var timePart = parts[1]
  var ampm = parts[2]

  if (!datePart || !timePart) {
    return null
  }

  var dateParts = datePart.split('-')
  var timeParts = timePart.split(':')

  if (dateParts.length !== 3 || timeParts.length !== 2) {
    return null
  }

  var year = parseInt(dateParts[0], 10)
  var month = parseInt(dateParts[1], 10) - 1
  var day = parseInt(dateParts[2], 10)
  var hours = parseInt(timeParts[0], 10)
  var minutes = parseInt(timeParts[1], 10)

  if (ampm && ampm.toUpperCase() === 'PM' && hours < 12) {
    hours += 12
  }

  if (ampm && ampm.toUpperCase() === 'AM' && hours === 12) {
    hours = 0
  }

  return new Date(year, month, day, hours, minutes)
}

/**
 * Update countdown banner.
 */
function updateCountdown() {
  var now = new Date().getTime()
  var distance = endDate.getTime() - now

  if (
    !startDate ||
    !endDate ||
    isNaN(startDate.getTime()) ||
    isNaN(endDate.getTime())
  ) {
    document.getElementById('timer').innerHTML = ""
    return
  }

  if (now < startDate.getTime()) {
    document.getElementById('countdownSection').style.display = 'none'
    return
  }

  if (distance < 0) {
    if (bannerExpiredText) {
      document.getElementById('announcementBanner').style.display = 'block'
      document.getElementById('bannerText').style.display = 'none'
      document.getElementById('bannerTextExpired').style.display = 'block'
      document.getElementById('timer').style.display = 'none'
      document.getElementById('countdownSection').style.display = 'flex'
    } else {
      document.getElementById('countdownSection').style.display = 'none'
    }

    clearInterval(countdownInterval)
    return
  }

  var days = Math.floor(distance / (1000 * 60 * 60 * 24))
  var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
  var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
  var seconds = Math.floor((distance % (1000 * 60)) / 1000)

  document.getElementById('days').innerHTML = days
  document.getElementById('hours').innerHTML = hours
  document.getElementById('minutes').innerHTML = minutes
  document.getElementById('seconds').innerHTML = seconds
  document.getElementById('countdownSection').style.display = 'block'
  document.getElementById('bannerText').style.display = 'block'
  document.getElementById('bannerTextExpired').style.display = 'none'
}

if (countdownSection) {
  /**
   * Run functions and set interval.
   */
  updateCountdown()
  countdownInterval = setInterval(updateCountdown, 1000)
}
